/**
 * Include a CSS file dynamically
 *
 * @param {function} file
 * @param {string} media
 * @param {string} place
 * @returns {Promise}
 * @package stylr
 */
import devlog from './devlog';

export default function includeCSS(
    file,
    media = 'all',
    async = false,
    place = 'body'
) {
    return new Promise( ( resolve, reject ) => {
        devlog( `%cIncluding ${file}`, 'color: #ccc' );
        let element = document.createElement( 'link' );
        element.href = file;
        element.rel = 'stylesheet';
        if ( media ) {
            element.media = media;
        }
        if ( async ) {
            element.async = async;
        }
        element.onload = () => {
            devlog( `%cFile included "${file}"`, 'color: green' );
            resolve();
        };
        element.onerror = () => {
            devlog( `%cFile could not be included "${file}"`, 'color: red' );
            reject();
        };
        document[place].appendChild( element );
    });
}
